import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Title, Youtube } from './AMCAD.style';

class ScalpPowerShot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Container>
          <Title>スカルプパワーショット基本の使い方</Title>
          <Youtube>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/qlcSvpaDXVo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </Youtube>
        </Container>
      </React.Fragment>
    );
  }
}

ScalpPowerShot.defaultProps = {
  // copy: {},
};
ScalpPowerShot.propTypes = {
  // copy: PropTypes.shape({}),
  // locale: PropTypes.string.isRequired,
  // updateError: PropTypes.func.isRequired,
};
const mapState = state => ({
  copy: state.salonConsultationTop,
  locale: state.locale,
});
const mapDispatch = dispatch => ({
  updateError: error => dispatch({ type: 'UPDATE_ERROR', error }),
});
export default connect(mapState, mapDispatch)(ScalpPowerShot);



// WEBPACK FOOTER //
// ./src/pages/ExtraPage/AMCAD/ScalpPowerShot.js